export default "__VITE_ASSET__CvbHx5Y9__"